module.exports = class Popup
  constructor: (position, elmt)->

